module.exports = __webpack_public_path__ + "images/119_640.jpg";